// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"575a7aa7","977":"bd528579"}[chunkId] + ".chunk.js";
};